if (!customElements.get('lp-sticky-header')) {
  customElements.define(
    'lp-sticky-header',
    class LPStickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback(ev) {
        this.header = document.querySelector(this.getAttribute('data-query-selector'));
        const { top } = this.header.getBoundingClientRect();
        this.header.style.position = 'sticky';
        this.header.style.top = top + 'px';
        this.header.style.zIndex = 4;
      }
    }
  );
}
